/* Sovereign Abundance quiz funnel (step 14, page QF: the quiz alone, its result as the sales page). Hand-written.
   1. Line above the title per ad: the ad name (ad_name, else utm_content) swaps [data-cNN] and [data-f-<format>].
   2. Links to the product page (a[data-pdp]) carry every parameter of the page URL and the chosen tier (?tier=1|2|3);
      a click publishes lp_cta_click.
   3. The quiz (#qf): one .qs screen at a time. Answers with data-t are tags (N, A, W; the most frequent picks the
      verdict, ties go to #qf[data-tie]); answers with data-v are stored under the screen's data-key, with data-say as
      the words read back; data-multi screens toggle answers and move on with .qgo (data-none clears the others);
      data-card buttons only move on; data-k is the anchor (shows li.qanchor[data-k]); .qload screens move on by
      themselves after data-auto ms. Every screen passed publishes lp_quiz_step; the verdict lp_quiz_result.
   4. The result: the sections marked .qafter (the result, offer, proof, FAQ, footer) show at the end; [data-echo=key] gets her words; [data-if=key:val]
      shows only when that answer was given (tried:some / tried:none for the multi screen).
   5. The discount code in #qf[data-code] is applied on every product-page link (/discount/<code>?redirect=…).
   6. The set-up: .tier buttons pick the tier the product-page links open on (default .tiers[data-default], or the anchor
      answer's data-tier); links with data-tierlabel say the tier ("Send me the 2 + 1 →"). Ties: A, then W, then N.
   ?all=1 shows every screen and result (review). Nothing is stored. */
(function () {
  var q = new URLSearchParams(location.search);
  var uc = (q.get('ad_name') || q.get('utm_content') || '').toLowerCase();
  var m = uc.match(/(?:^|_)(c\d\d)(?=[a-z]?(?:_|$))/);
  var key = m ? m[1] : null;
  if (key) document.querySelectorAll('[data-' + key + ']').forEach(function (el) { el.innerHTML = el.getAttribute('data-' + key); });
  ['ui-mockup', 'ugc-image', 'native-long-copy', 'comparison', 'news-style', 'crossed-out-enemy'].forEach(function (f) {
    if (uc.indexOf('_' + f + '_') > -1) document.querySelectorAll('[data-f-' + f + ']').forEach(function (el) { el.innerHTML = el.getAttribute('data-f-' + f); });
  });
  var page = document.body.getAttribute('data-lp') || 'lp';
  function pub(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {} }

  // product-page links: the visitor's parameters plus the chosen tier
  var pass = [];
  q.forEach(function (v, k) { if (!/^(view|preview_theme_id|_ab|_fd|_sc|tier|qty|variant|all|clean)$/.test(k)) pass.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); });
  var links = [].slice.call(document.querySelectorAll('a[data-pdp]'));
  links.forEach(function (a, i) {
    a.setAttribute('data-base', a.href.split('?')[0]);
    a.addEventListener('click', function () { pub('lp_cta_click', { page: page, link: i + 1, tier: tier, verdict: verdict || 'none', skip: a.hasAttribute('data-skip'), concept: key || 'default' }); });
  });
  var tier = '2', verdict = null;
  var qfbox = document.getElementById('qf'), code = qfbox ? qfbox.getAttribute('data-code') : null;
  var tierLabel = { '1': 'Send me 1 piece →', '2': 'Send me the 2 + 1 →', '3': 'Send me the 3 + 2 →' };
  function setTier(t) {
    tier = String(t);
    document.querySelectorAll('.tier').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-tier') === tier); });
    links.forEach(function (a) {
      var u = a.getAttribute('data-base') + '?tier=' + tier + (pass.length ? '&' + pass.join('&') : '');
      // the code on the page (#qf[data-code]) is applied on the way: /discount/<code>?redirect=<product page>
      if (code) { var o = u.match(/^https?:\/\/[^\/]+/); o = o ? o[0] : ''; u = o + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(u.slice(o.length)); }
      a.href = u;
      if (a.hasAttribute('data-tierlabel')) a.textContent = tierLabel[tier];
    });
  }
  var tiers = document.querySelector('.tiers');
  setTier(tiers ? tiers.getAttribute('data-default') || '2' : '2');
  document.querySelectorAll('.tier').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); setTier(b.getAttribute('data-tier')); });
  });

  var box = document.getElementById('qf');
  if (!box) return;
  var all = q.get('all') === '1';
  var screens = [].slice.call(box.querySelectorAll('.qs'));
  var bar = document.getElementById('qfbar'), back = document.getElementById('qfback');
  var after = [].slice.call(document.querySelectorAll('.qafter'));
  var tags = [], answers = {}, says = {}, kpick = null, ktier = null, i = 0, timer = null;

  if (all) { document.body.classList.add('all'); return; }
  after.forEach(function (s) { s.classList.add('qhide'); });

  function show() {
    screens.forEach(function (s, k) { s.classList.toggle('on', k === i); });
    if (bar) bar.style.width = (i / screens.length * 100) + '%';
    if (back) back.classList.toggle('on', i > 0 && i < screens.length);
    clearTimeout(timer);
    var s = screens[i];
    if (s && s.classList.contains('qload')) timer = setTimeout(function () { step('auto'); }, +(s.getAttribute('data-auto') || 3000));
    window.scrollTo(0, 0);
  }
  function step(answer) {
    var s = screens[i];
    pub('lp_quiz_step', { page: page, step: i + 1, screen: s.getAttribute('data-q') || String(i + 1), answer: answer || 'next', concept: key || 'default' });
    i++;
    if (i < screens.length) show(); else finish();
  }
  function list(words) {
    if (words.length < 2) return words.join('');
    return words.slice(0, -1).join(', ') + ' and ' + words[words.length - 1];
  }
  function finish() {
    screens.forEach(function (s) { s.classList.remove('on'); });
    if (bar) bar.style.width = '100%'; if (back) back.classList.remove('on');
    var n = {}; tags.forEach(function (t) { if (t) n[t] = (n[t] || 0) + 1; });
    var r = box.getAttribute('data-tie') || 'A';
    ['A', 'W', 'N'].forEach(function (t) { if ((n[t] || 0) > (n[r] || 0)) r = t; });
    verdict = r;
    if (ktier) setTier(ktier);
    document.querySelectorAll('.qres').forEach(function (el) { el.classList.toggle('on', el.getAttribute('data-r') === r); });
    document.querySelectorAll('.qanchor').forEach(function (el) { el.classList.toggle('on', el.getAttribute('data-k') === kpick); });
    document.querySelectorAll('[data-echo]').forEach(function (el) {
      var k = el.getAttribute('data-echo'), v = says[k];
      if (v && v.length) el.textContent = Array.isArray(v) ? list(v) : v;
    });
    document.querySelectorAll('[data-if]').forEach(function (el) {
      var p = el.getAttribute('data-if').split(':'), a = answers[p[0]], ok;
      if (Array.isArray(a)) ok = p[1] === 'none' ? a.indexOf('none') > -1 : (p[1] === 'some' ? a.length > 0 && a.indexOf('none') < 0 : a.indexOf(p[1]) > -1);
      else ok = a === p[1];
      el.classList.toggle('qoff', !ok);
    });
    after.forEach(function (s) { s.classList.remove('qhide'); });
    box.classList.add('done');
    pub('lp_quiz_result', { page: page, result: r, anchor: kpick || 'none', tier: tier, where: answers.where || '', tried: (answers.tried || []).join('+'), age: answers.age || '', faith: answers.faith || '', try: answers['try'] || '', concept: key || 'default' });
    window.scrollTo(0, 0);
  }

  box.addEventListener('click', function (e) {
    var b = e.target.closest('.qs button');
    if (b) {
      e.preventDefault();
      var s = screens[i], k = s.getAttribute('data-key');
      if (s.hasAttribute('data-multi')) {
        if (b.classList.contains('qgo')) {
          var picked = [].slice.call(s.querySelectorAll('button.sel'));
          if (!picked.length) { s.classList.add('need'); return; }
          s.classList.remove('need');
          answers[k] = picked.map(function (p) { return p.getAttribute('data-v'); });
          says[k] = picked.filter(function (p) { return !p.hasAttribute('data-none'); }).map(function (p) { return p.getAttribute('data-say') || p.textContent; });
          step(answers[k].join('+'));
          return;
        }
        if (b.hasAttribute('data-none')) s.querySelectorAll('button.sel').forEach(function (p) { if (p !== b) p.classList.remove('sel'); });
        else { var nb = s.querySelector('button[data-none]'); if (nb) nb.classList.remove('sel'); }
        b.classList.toggle('sel');
        return;
      }
      var t = b.getAttribute('data-t'), v = b.getAttribute('data-v'), kk = b.getAttribute('data-k');
      tags[i] = t || null;
      if (k && v !== null) { answers[k] = v; says[k] = b.getAttribute('data-say') || (b.querySelector('span') || b).textContent; }
      if (kk !== null) { kpick = kk; ktier = b.getAttribute('data-tier'); }
      step(t || v || kk || 'next');
      return;
    }
    if (e.target === back) { e.preventDefault(); if (i > 0) { i--; tags[i] = null; show(); } }
  });
  show();
})();

/* FALL25 and the launch gifts end on the Sunday of the current week in New York (today on a Sunday): rolling,
   never out of date (William, 2026-10-29). .js-deadline "Sunday, November 1" · .js-deadline-short "Sun, Nov 1" ·
   .js-deadline-md "Nov 1"; the text written in the page is the fallback without JavaScript. */
(function () {
  var els = document.querySelectorAll('.js-deadline, .js-deadline-short, .js-deadline-md');
  if (!els.length) return;
  var d;
  try { d = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })); } catch (e) { d = new Date(); }
  d.setDate(d.getDate() + (7 - d.getDay()) % 7);
  var D = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var M = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var day = D[d.getDay()], mon = M[d.getMonth()], n = d.getDate();
  els.forEach(function (e) {
    e.textContent = e.classList.contains('js-deadline-md') ? mon.slice(0, 3) + ' ' + n
      : e.classList.contains('js-deadline-short') ? day.slice(0, 3) + ', ' + mon.slice(0, 3) + ' ' + n
      : day + ', ' + mon + ' ' + n;
  });
})();
